var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCollaboration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 55.97,
    viewBox: "0 0 50 55.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "collaboration-svgrepo-com",
    transform: "translate(-27.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3491",
    "data-name": "Group 3491",
    transform: "translate(44.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3490",
    "data-name": "Group 3490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M196.374,14.215a8.04,8.04,0,1,0-10.3,0,8.028,8.028,0,0,0-2.893,6.172V26.56a1.87,1.87,0,0,0,1.87,1.87H197.4a1.87,1.87,0,0,0,1.87-1.87V20.387A8.028,8.028,0,0,0,196.374,14.215Z",
    transform: "translate(-183.182)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3493",
    "data-name": "Group 3493",
    transform: "translate(27.306 27.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3492",
    "data-name": "Group 3492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M40.5,266.8a8.04,8.04,0,1,0-10.3,0,8.028,8.028,0,0,0-2.893,6.172v6.172a1.87,1.87,0,0,0,1.87,1.87H41.521a1.87,1.87,0,0,0,1.87-1.87v-6.172A8.028,8.028,0,0,0,40.5,266.8Z",
    transform: "translate(-27.306 -252.586)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3495",
    "data-name": "Group 3495",
    transform: "translate(61.221 27.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3494",
    "data-name": "Group 3494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5629",
    "data-name": "Path 5629",
    d: "M351.111,266.8a8.04,8.04,0,1,0-10.3,0,8.028,8.028,0,0,0-2.893,6.172v6.172a1.87,1.87,0,0,0,1.87,1.87h12.345a1.87,1.87,0,0,0,1.87-1.87v-6.172A8.028,8.028,0,0,0,351.111,266.8Z",
    transform: "translate(-337.919 -252.586)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3497",
    "data-name": "Group 3497",
    transform: "translate(44.896 29.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3496",
    "data-name": "Group 3496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5630",
    "data-name": "Path 5630",
    d: "M202.656,282.481l-4.992-4.992v-7.1a1.87,1.87,0,0,0-3.741,0v7.1l-4.992,4.992a1.87,1.87,0,0,0,2.645,2.645l4.217-4.217,4.217,4.217a1.87,1.87,0,0,0,2.645-2.645Z",
    transform: "translate(-188.383 -268.516)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollaboration);
export default __webpack_public_path__ + "static/media/icon-collaboration.31f436913cc7dce2024a5ec85934a2ed.svg";
export { ForwardRef as ReactComponent };